const objFunc = () => {
  return {
    predictions: [],
    placeDetails: {}
  }
}

export default objFunc()

export const defaultObj = objFunc()
